module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Medium-7fe92bb1fe75c84e473aa3a5fb7c1de9.ttf";